/*
|--------------------------------------------------------------------------
| site header user prefs module
|--------------------------------------------------------------------------
*/

/* ========================================================================== *\
IMPORTS
\* ========================================================================== */

import $ from 'jquery';
import contrast from '../2-utilities/a11y/contrast-utility';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
CONSTANTS
\* ========================================================================== */

const
    /**
     * The module name
     * @type {String}
     */
    moduleName = 'site-header__control-panel',

    /**
     * Lookup table for selectors
     * @type {Object}
     */
    selectors = {
        base: 'js-' + moduleName,
        setContrastBtn: 'js-' + moduleName + '__contrast'
    },
    modifiers = {
        openModifier: '--is-open',
        activeModifier: '--is-active'
    },
    sitecoreEditMode = $('.sc-edit')

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
SETUP site header search
\* ========================================================================== */

const setContrast = (e) => {
    e.preventDefault();
    if ($(e.currentTarget).data('set-contrast') == 'high') {
        contrast.enable()
    } else {
        contrast.disable()
    }
}

/* == END SETUP site header search ===================================================== */

/* ========================================================================== *\
EVENT HANDLING
\* ========================================================================== */


const bindHandlers = () => {
   $('.' + selectors.setContrastBtn).on('click', setContrast);
}


/* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
INITIALIZATION
\* ========================================================================== */

/**
 * Initialize variant module
 */
function init() {
    // initialise by setting the user preference
    contrast.toggleContrast();

   bindHandlers();
}

if (document.getElementsByClassName('.' + selectors.base)){
    init()
}

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
EXPORTS
\* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */
